<template>
  <div>
    <h1>Not found</h1>
    <router-link to="/">Homepage</router-link>
  </div>
</template>
